import type { ReactNode } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import FormGroup from 'react-bootstrap/FormGroup';
import FormControl from 'react-bootstrap/FormControl';

import DataTablePagination from './DataTablePagination';
import type { DataTablePaginationProps } from './DataTablePagination';

/**
 * Низ таблицы: пагинация + селектор размера страницы.
 * Используется как containerComponent PagingPanel (получает её пропсы спредом).
 */
export interface DataTablePagingPanelProps extends DataTablePaginationProps {
  pageSize?: number;
  pageSizes?: Array<number | 'all'>;
  onChange?: (pageSize: number) => void;
  children?: ReactNode;
}

const DataTablePagingPanel = (props: DataTablePagingPanelProps) => {
  const { pageSize, pageSizes, onChange } = props;

  return (
    <Row>
      <Col lg={ 12 }>
        <DataTablePagination { ...props } />

        <div className='float-end pagination'>
          <FormGroup controlId='datatable-sizes-selector'>
            <FormControl
              as='select'
              value={ pageSize }
              onChange={ ({ target }) => onChange(Number(target?.value)) }
            >
              { pageSizes.map(size => (
                <option key={ size } value={ size }>
                  { `${ size } записей на страницу` }
                </option>
              )) }
            </FormControl>
          </FormGroup>
        </div>
      </Col>
    </Row>
  );
};

export default DataTablePagingPanel;
